<template>
	<v-container fluid class="crm-index d-flex flex-column"
		:style="'height:'+$store.getters['general/availableHeight']+'px;'">
		<div class="d-flex align-center justify-end mb-2 flex-shrink-0">
			<v-tooltip bottom>
				<template v-slot:activator="{ on, attrs }">
					<v-btn
						fab
						dark
						x-small
						color="green"
						class="mx-2"
						v-if="lastWorkingContract"
						@click.stop="() => { selectRow(item); toSubcontractDetail(lastWorkingContract); }"
						v-bind="attrs"
						v-on="on"
					>
						<v-icon small dark>mdi-briefcase-outline</v-icon>
					</v-btn>
				</template>
				<span>Continuar Trabajando en Último Subcontrato</span>
			</v-tooltip>
			<div class="d-flex align-center" style="flex: 1;max-width: 400px;">
				<v-icon color="#524D4D" @click="searchForString">mdi-magnify</v-icon>
				<v-text-field
					v-model="searchInput"
					:loading="$store.state.contracts.loadingCompanyContractsList"
					outlined
					dense
					hide-details
					item-text="name"
					item-value="id"
					return-object
					clearable
					label="Búsqueda"
					class="mb-0 mr-2 custom-height-search custom-height-calendar"
					color="#524D4D"
					@input="sendToSearch"
				></v-text-field>
			</div>
			<DataTablePagination
				:options.sync="options"
				:item-length="$store.state.contracts.companyContractsListCount"
				:loading-info="$store.state.contracts.loadingCompanyContractsList"
				:showOrderBy="true"
				items-type="subcontracts"
			/>
		</div>
		<div class="table-container flex-grow-1 pb-2">
			<v-data-table
				:headers="headers"
				:items="$store.state.contracts.companyContractsList"
				:server-items-length="$store.state.contracts.companyContractsListCount"
				item-key="id"
				class="budget-table"
				:loading="$store.state.contracts.loadingCompanyContractsList"
				:options.sync="options"
				loading-text="Cargando datos..."
				hide-default-footer
				@click:row="selectRow"
				:item-class="selectedRowClass"
				:footer-props="{
					itemsPerPageText: 'Filas por página',
					'items-per-page-options': itemsPerPageOptions
				}"
			>
				<template v-slot:item.lp="{ item }">
					<td v-if="isFirstWithLP(item)" :rowspan="getRowspanCount(item)" class="with-divider">
						<p class="mb-0 font-weight-bold" style="width: 70px;">LP {{ item.morphable?.project_line_info?.project_line?.number }}</p>
					</td>
					<td v-else style="display: none;"></td>
				</template>
				<template v-slot:item.serial="{ item }">
					<div class="d-flex align-center fill-height">
						<v-tooltip bottom v-if="lastWorkingContract && lastWorkingContract.id == item.id">
							<template v-slot:activator="{ on, attrs }">
								<div 
									v-bind="attrs"
									v-on="on"
									class="last-worked-ribbon d-flex align-center justify-center">
									<v-icon x-small color="white" class="ribbon-icon">mdi-briefcase-outline</v-icon>
								</div>
							</template>
							<span>Lo trabajaste hace poco</span>
						</v-tooltip>
						<div class="py-1 px-2">
							<div style="width:140px;"><b>{{ getCode(item) }}</b></div>
							<div class="mr-2 d-flex align-center">
								<v-icon class="mr-1" x-small>mdi-calendar</v-icon>
								<p class="mb-0" style="font-size: 10px;">{{ item.created_at | toDate }}</p>
							</div>
							<v-chip
								color="green"
								label
								outlined
								x-small
								v-if="item.id == $store.state.contracts.companyContractsLastId"
							>
								<b>Último Creado</b>
							</v-chip>
							<!-- <v-chip
								color="green"
								label
								x-small
								dark
								v-if="lastWorkingContract && lastWorkingContract.id == item.id"
								class="px-1"
							>
								<b>Lo trabajaste hace poco</b>
							</v-chip> -->
						</div>
					</div>
				</template>
				<template v-slot:item.included_subcontracts="{ item }">
					<div class="subcontracts-list">
						<div v-if="item.subcontract_included_info.length == 0">
							<p class="mb-0" style="font-size: 10px;">Sin proyectos incluidos</p>
						</div>
						<div
							v-else
							v-for="(subcontract ,index) in item.subcontract_included_info"
							:key="subcontract.item + '_' + subcontract.morphable_id + '_' + index"
							class="subcontract-item">
							<v-icon size="5" class="subcontract-icon">mdi-circle</v-icon>
							<div class="subcontract-content">
								<p class="mb-0 subcontract-name">{{ subcontract.name }}</p>
								<p v-if="subcontract.subtitle" class="mb-0 subcontract-subtitle">{{ subcontract.subtitle }}</p>
							</div>
						</div>
					</div>
				</template>
				<template v-slot:item.contractor="{ item }">
					<div class="d-flex align-center">
						<div class="d-flex flex-column flex-grow-1">
							<b>{{ getUserName(item) }}</b>
							<div>{{ item.contractor ? item.contractor.email:'No identificado'}}</div>
						</div>
						<div class="d-flex align-self-start align-start justify-end">
							<v-tooltip bottom v-if="item.contractor?.company_profile && item.contractor?.accreditation?.status">
								<template v-slot:activator="{ on, attrs }">
									<v-icon small color="#FF1209"
										v-bind="attrs"
										v-on="on">mdi-domain</v-icon>
								</template>
								<span>Proveedor Empresa</span>
							</v-tooltip>
							<v-tooltip bottom v-else>
								<template v-slot:activator="{ on, attrs }">
									<v-icon small color="#959595"
										v-bind="attrs"
										v-on="on">mdi-account</v-icon>
								</template>
								<span>Proveedor Persona Natural</span>
							</v-tooltip>
						</div>
					</div>
				</template>
				<template v-slot:item.details="{ item }">
					<div>
						<div class="d-flex">
							<div class="d-flex align-center flex-grow-1">
								<v-icon small class="mr-2">mdi-ruler-square</v-icon> <p class="mb-0 font-weight-bold">{{ item.morphable?.name }}</p>
							</div>
							<v-tooltip bottom>
								<template v-slot:activator="{ on, attrs }">
									<v-btn
										icon
										color="warning"
										x-small
										v-bind="attrs"
										v-on="on"
										disabled
										@click.stop="() => { selectRow(item); gotToAssociation(item); }"
									>
										<v-icon dark small>mdi-eye-outline</v-icon>
									</v-btn>
								</template>
								<span>Ir al detalle</span>
							</v-tooltip>
						</div>
						<div class="d-flex align-center">
							<div class="d-flex align-center flex-grow-1" v-if="item.morphable">
								<div class="d-flex align-center flex-grow-1" v-if="item.morphable.responsible">
									<v-icon small class="mr-2" color="green">mdi-account-check-outline</v-icon>
									<v-tooltip bottom>
										<template v-slot:activator="{ on, attrs }">
											<p
												class="mb-0 text-truncate font-weight-bold"
												v-bind="attrs"
												v-on="on"
											>
												{{ item.morphable.responsible.profile.name + ' ' + item.morphable.responsible.profile.lastname  + ' ' + item.morphable.responsible.profile.second_lastname }}
											</p>
										</template>
										<span>{{ item.morphable.responsible.profile.name + ' ' + item.morphable.responsible.profile.lastname  + ' ' + item.morphable.responsible.profile.second_lastname }}</span>
									</v-tooltip>
								</div>
								<div class="d-flex align-center flex-grow-1" v-else>
									<v-icon small class="mr-2" color="warning">mdi-account-cancel-outline</v-icon>
									<b>Sin Responsable</b>
								</div>
							</div>
							<v-menu offset-y z-index="9999" content-class="menu-bg-white" style="z-index: 9999; background-color: white;">
								<template v-slot:activator="{ on, attrs }">
									<v-tooltip bottom>
										<template v-slot:activator="{ on: tooltipOn, attrs: tooltipAttrs }">
											<v-btn
												icon
												color="warning"
												x-small
												@click="selectRow(item)"
												:disabled="!$checkPermissions(['assign_responsible_user'])"
												v-bind="{ ...attrs, ...tooltipAttrs }"
												v-on="{ ...on, ...tooltipOn }"
											>
												<v-icon dark small>mdi-swap-horizontal-bold</v-icon>
											</v-btn>
										</template>
										<span>Cambiar Responsable</span>
									</v-tooltip>
								</template>
								<v-list dense class="py-0" max-height="200" style="z-index: 9999;background-color: white;">
									<v-list-item dense class="mb-1" style="min-height: 25px; background: #959595;">
										<p class="caption mb-0 font-weight-bold white--text">Cambiar Responsable</p>
									</v-list-item>
									<v-list-item-group color="#524D4D">
										<v-list-item
											v-for="(responsible, index) in companyUserList"
											:key="index"
											dense
											@click.stop="() => { selectRow(item); changeResponsible(item, responsible.id); }"
										>
											<v-list-item-title dense>
												<div class="d-flex align-center">
													<img :src="responsible.profile.avatar" class="user-avatar mr-2" v-if="responsible?.profile?.avatar"/>
													<v-icon v-else class="user-avatar icon mr-2" color="#524D4D">mdi-account</v-icon>
													<div>
														<p class="mb-0">{{ responsible.profile?.name }} {{ responsible.profile?.lastname }} {{ responsible.profile?.second_lastname }}</p>
														<p class="mb-0 caption">{{ responsible.email }}</p>
													</div>
												</div>
											</v-list-item-title>
										</v-list-item>
									</v-list-item-group>
								</v-list>
							</v-menu>
						</div>
					</div>
				</template>
				<template v-slot:item.address="{ item }">
					<div>
						<p class="mb-0 font-weight-bold">{{ item.morphable?.name || item.morphable?.info?.project_detail || 'Sin Nombre' }}</p>
						<p class="mb-0">{{ item.morphable?.info?.address?.address || 'Sin Dirección' }}</p>
						<p class="mb-0">{{ item.morphable?.info?.project_type?.name || 'Sin Tipo de Proyecto' }}</p>
						<div v-if="item.subcontract_included_info?.length">
							<v-divider class="my-1"></v-divider>
							<p class="mb-0 font-weight-bold">Proyectos Incluidos</p>
							<div class="d-flex flex-column gap-1 mt-0">
								<v-chip
									v-for="(subcontract, idx) in item.subcontract_included_info_"
									:key="idx"
									x-small
									outlined
									color="#959595"
									text-color="#959595"
									class="chip-subcontract"
								>
									<div class="d-flex flex-column" style="gap: 2px;">
										<span class="chips-label">{{ getSubcontractTypeLabel(subcontract.item_type) }}</span>
										<span class="chips-name">{{ subcontract.name }}</span>
										<span v-if="subcontract.subtitle" class="chips-subtitle">{{ subcontract.subtitle }}</span>
									</div>
								</v-chip>
							</div>
						</div>
					</div>
				</template>
				<template v-slot:item.status="{ item }">
					<div class="py-1">
						<div class="d-flex align-center flex-grow-1">
							<div class="d-flex align-center flex-grow-1">
								<v-chip
									:color="item.last_status?.status | contractStatusColor"
									label
									outlined
									x-small
									class="mb-1 px-1 wrap-chip d-flex align-center flex-grow-1 justify-center"
								>
									<div class="d-flex align-center flex-column text-center flex-grow-1">
										<b>{{ item.last_status?.status | contractStatusSubcontractor }}</b>
										<v-tooltip bottom>
											<template v-slot:activator="{ on, attrs }">
												<div class="d-flex align-center"
													v-bind="attrs"
													v-on="on">
													<v-icon class="mr-1" x-small>mdi-calendar</v-icon>
													<p class="mb-0 caption font-weight-bold" style="font-size: 10px;">{{ item.last_status?.created_at | toDate }}</p>
												</div>
											</template>
											<span>Fecha de último cambio de estado</span>
										</v-tooltip>
										<v-tooltip bottom>
											<template v-slot:activator="{ on, attrs }">
												<v-icon
													style="position: absolute;bottom: 2px;right: 2px;" size="9px"
													:color="getCurrentDiffColor(item.last_status?.created_at)"
													v-bind="attrs"
													v-on="on">mdi-circle</v-icon>
											</template>
											<span>Tiempo de espera: {{ getCurrentDiffText(item.last_status?.created_at) }}</span>
										</v-tooltip>
									</div>
								</v-chip>
							</div>

							<!-- <v-menu offset-y z-index="9999" content-class="menu-bg-white" style="z-index: 9999; background-color: white;">
								<template v-slot:activator="{ on, attrs }">
									<v-btn
										dark
										small
										icon
										color="#524D4D"
										v-bind="attrs"
										v-on="on"
									>
										<v-icon dark small>mdi-swap-horizontal-bold</v-icon>
									</v-btn>
								</template>
								<v-list dense class="py-0" max-height="200" style="z-index: 9999;background-color: white;">
									<v-list-item dense class="mb-1" style="min-height: 25px; background: #959595;">
										<p class="caption mb-0 font-weight-bold white--text">Cambiar Estado</p>
									</v-list-item>
									<v-list-item-group color="#524D4D">
										<v-list-item
											v-for="(status, index) in contractStatuses"
											:key="index"
											dense
											@click.stop="() => { selectRow(item); changeContractStatus(item.id, status.value); }"
										>
											<v-list-item-title dense>
												{{ status.title }}
											</v-list-item-title>
										</v-list-item>
									</v-list-item-group>
								</v-list>
							</v-menu> -->
						</div>
					</div>
				</template>
				<template v-slot:item.actions="{ item }">
					<div class="d-flex" style="gap: 5px;">
						<div>
							<v-tooltip bottom v-if="$store.state.user.userInfo">
								<template v-slot:activator="{ on, attrs }">
									<v-btn
										icon
										dark
										x-small
										color="#959595"
										@click.stop="() => { selectRow(item); toSubcontractDetail(item); }"
										v-bind="attrs"
										v-on="on"
									>
										<v-icon small dark>mdi-briefcase-outline</v-icon>
									</v-btn>
								</template>
								<span>Ver Detalle</span>
							</v-tooltip>
						</div>
						<div>
							<v-tooltip bottom>
								<template v-slot:activator="{ on, attrs }">
									<v-btn
										icon
										dark
										x-small
										color="#959595"
										@click.stop="() => { selectRow(item); $router.push({ name: 'ProjectCostBreakdown', params: { id: item.morphable_id }, hash: '#external' }); }"
										v-bind="attrs"
										v-on="on"
									>
										<v-icon>mdi-currency-usd</v-icon>
									</v-btn>
								</template>
								<span>Ver Tabla de Costo del Proyecto</span>
							</v-tooltip>
						</div>
					</div>
				</template>
			</v-data-table>
		</div>
		<!-- <div class="d-flex align-center justify-end mt-2">
			<DataTablePagination
				:options.sync="options"
				:item-length="$store.state.contracts.companyContractsListCount"
				:loading-info="$store.state.contracts.loadingCompanyContractsList"
				:showOrderBy="true"
				items-type="subcontracts"
			/>
		</div> -->
  </v-container>
</template>

<script>
import moment from 'moment'
import _debounce from 'lodash/debounce'
import { eventBus } from '@/components/Helpers/Events/NotificationsEventBus'
import {addNewStatus} from '@/helpers/api/contracts'
import { getProjectCode } from '@/helpers/helpers'

import {setResponsible as setResponsiblePreProject} from '@/helpers/api/preprojects'
import {setResponsible as setResponsibleProject} from '@/helpers/api/projects'
import {assignScheduleToUser} from '@/helpers/api/crm'
import DataTablePagination from '@/components/Helpers/Components/DataTablePagination'

export default {
	name: 'ContractIndex',
	components: {
		DataTablePagination,
	},
  data() {
    return {
      search: '',
			selectedRowItem: null,
			searchInput: null,
			lastWorkingContract: null,
			itemsPerPageOptions: [10, 25, 50, 100, 200],
      options: {
        page: 1,
        itemsPerPage: 50,
        order_by: 2,
      },
			contracts: [],
			loading: true,
			contractStatuses: [
				{value: 1, title: 'Creado'},
				{value: 2, title: 'Esperando Pago Subcontrato'},
				{value: 3, title: 'Subcontrato Pagado'},
				{value: 4, title: 'Esperando Visto Bueno Empresa / Profesional'},
				{value: 5, title: 'Visto Bueno Empresa / Profesional'},
				{value: 6, title: 'Enviado a Proveedor'},
				{value: 7, title: 'Observado por Proveedor'},
				{value: 8, title: 'Aceptado'},
				{value: 9, title: 'Rechazado'},
				{value: 10, title: 'Firmado Proveedor'},
				{value: 11, title: 'Firmado Ambas Partes'},
			]
    };
  },
  computed: {
		companyUserList(){
			return this.$store.state.users.usersList
		},
		selectedCompany(){
			return this.$store.state.companies.selectedCompany
		},
		headers(){
			let headers = [
				{ text: 'LP', value: 'lp', class: 'with-divider', cellClass: 'with-divider', sortable: false },
				{ text: 'Nº', value: 'serial', class: 'with-divider', cellClass: 'with-divider first-column-custom', sortable: false },
				{ text: 'Subcontratos Incluidos', value: 'included_subcontracts', class: 'with-divider', cellClass: 'with-divider column-subcontracts-included px-1', width: '20%', sortable: false },
				{ text: 'Proveedor', value: 'contractor', class: 'with-divider', cellClass: 'with-divider', width: '15%' },
        { text: 'Seguimiento y Responsable', value: 'details', class: 'with-divider', cellClass: 'with-divider', width: '20%' },
        { text: 'Proyecto', value: 'address', class: 'with-divider column-project', cellClass: 'with-divider column-project', width: '25%' },
        { text: 'Estado', value: 'status', class: 'with-divider column-status', cellClass: 'with-divider column-status', width: '15%' },
        { text: 'Acciones', value: 'actions', align: 'center', class: 'with-divider', cellClass: 'with-divider', sortable: false },
			]
			if(this.options.order_by != 2) {
				headers = headers.filter(h => h.value !== 'lp')
			}
			return headers
			// return headers.filter((header) => {
			// 	return this.$store.state.subcontracts.listingColumns[header.value]
			// })
		},
  },
	watch: {
    options: {
      handler() {
				this.reloadInfo()
      },
      deep: true,
    },
		selectedCompany(newValue){
			if(newValue){
				this.reloadInfo()
				this.$store.dispatch('users/getUserFromCompany')
			}
		}
	},
	mounted(){
		if(this.selectedCompany){
			this.reloadInfo()
		}
		const selectedRow = JSON.parse(localStorage.getItem('selected_contract_row'));
		if (selectedRow) {
			this.selectedRowItem = selectedRow
		}
		if(this.companyUserList.length == 0){
			this.$store.dispatch('users/getUserFromCompany')
		}
		this.setLastWorkingContract()
		eventBus.$on('changeGeneralOrderList', this.onChangeGeneralOrderList)
    eventBus.$on('reloadInformation', this.reloadInfo)
	},
	beforeDestroy(){
		eventBus.$off('changeGeneralOrderList', this.onChangeGeneralOrderList)
		eventBus.$off('reloadInformation', this.reloadInfo)
	},
  methods: {
		getRowspanCount(item){
			let count = 1
			const filtered = this.$store.state.contracts.companyContractsList.filter(contract => contract.morphable?.project_line_info?.project_line?.number == item.morphable?.project_line_info?.project_line?.number)
			count = filtered.length
			return count
		},
		isFirstWithLP(item){
			const firstWithLP = this.$store.state.contracts.companyContractsList.find(
				contract => contract.morphable?.project_line_info?.project_line?.number === item.morphable?.project_line_info?.project_line?.number
			)
			return firstWithLP && firstWithLP.id === item.id
		},
		getCode(contract){
			return getProjectCode(contract, contract.morphable)
		},
		onChangeGeneralOrderList(value){
			this.options.order_by = value
			this.debounceReloadInfo()
		},
		debounceReloadInfo: _debounce(function() { this.reloadInfo() }, 300),
		sendToSearch: _debounce(function() { this.searchForString() }, 800),
		selectRow(item){
			this.selectedRowItem = item.id
			localStorage.setItem('selected_contract_row', JSON.stringify(item.id))
		},
		selectedRowClass(item){
			if (this.selectedRowItem && this.selectedRowItem === item.id) {
				return 'selected-row-custom-item';
			}
			return ''
		},
		getCurrentDiffText(created_at){
			const date1 = moment()
			const date2 = moment(created_at)
			const diffInDays = date1.diff(date2, 'days')
			if(diffInDays == 1){
				return `${diffInDays} día`
			}
			return `${diffInDays} días`
		},
		getCurrentDiffColor(created_at){
			const date1 = moment()
			const date2 = moment(created_at)
			const diffInDays = date1.diff(date2, 'days')
			if(diffInDays > 5){
				return '#FF120B'
			}
			else if(diffInDays > 2){
				return 'orange'
			}
			return 'green'
		},
		getAddendumText(addendums){
			if(addendums.length == 1){
				return `${addendums.length} anexo`
			}
			else if(addendums.length > 1){
				return `${addendums.length} anexos`
			}
			return 'Sin Anexos'
		},
		searchForString(){
			this.options = {...this.options, ...{page: 1}}
			this.reloadInfo()
		},
		async changeResponsible(item, responsible_id){
			const item_type = this.getType(item.morphable_type)
			if(item_type == 'crm'){
				await assignScheduleToUser({schedule_id: this.conversation.schedule.user_schedule.id, new_user_id: responsible_id})
			}
			else if(item_type == 'preproject'){
				await setResponsiblePreProject({preproject_id: item.morphable_id, responsible_id})
			}
			else if(item_type == 'project'){
				await setResponsibleProject({project_id: item.morphable_id, responsible_id, from_state: 'contract', contract_id: item.id})
			}
			this.reloadInfo()
		},
		async changeContractStatus(contract_id, status){
			const resp = await addNewStatus({contract_id, status})
			if(resp.code == 200){
				this.reloadInfo()
			}
		},
		reloadInfo(){
			let data = {
				...this.options,
				start: (this.options.page - 1) * this.options.itemsPerPage,
				limit: this.options.itemsPerPage,
				contract_type: 3
			}
			if(this.searchInput){
				data = {...data, ...{search: this.searchInput}}
			}
			this.$store.dispatch('contracts/getContracts', data)
		},
		setLastWorkingContract(){
			const contract = localStorage.getItem('last_working_subcontract')
			if(contract){
				const contract_data = JSON.parse(contract)
				this.lastWorkingContract = contract_data
			}
		},
		getUserName(item){
			let name = ''
			if(item && item.contractor && item.contractor.profile){
				name = item.contractor.profile.name + ' ' + item.contractor.profile.lastname + ' ' + item.contractor.profile.second_lastname
			}
			else{
				name = 'No identificado'
			}
			return name
		},
		getCompanyProjects(){
			this.$store.dispatch('projects/getProjects')
		},
		toSubcontractDetail(contract){
			localStorage.setItem('last_working_subcontract', JSON.stringify(contract))
			this.$router.push({ name: 'SubcontractDetail', query: { id: contract.id } })
		},
		getTypeIcon(type){
			switch (type) {
				case "App\\Models\\BotConversation":
					return 'mdi-contacts-outline'
				case "App\\Models\\PreProject":
					return 'mdi-information-variant-circle-outline'
				case "App\\Models\\Project":
					return 'mdi-ruler-square'
				default:
					break;
			}
			return 'Otro'
		},
		getTypeName(type){
			switch (type) {
				case "App\\Models\\BotConversation":
					return 'CRM'
				case "App\\Models\\PreProject":
					return 'PreProyecto'
				case "App\\Models\\Project":
					return 'Proyecto'
				default:
					break;
			}
			return 'Otro'
		},
		getType(type){
			switch (type) {
				case "App\\Models\\BotConversation":
					return 'crm'
				case "App\\Models\\PreProject":
					return 'preproject'
				case "App\\Models\\Project":
					return 'project'
				default:
					break;
			}
			return 'Otro'
		},
		getSubcontractTypeLabel(itemType) {
			const labels = {
				'cost_table': 'Proyecto Principal',
				'stage': 'Etapa',
				'specialty': 'Especialidad',
				'reception': 'Recepción'
			};
			return labels[itemType] || itemType;
		}
  },
};
</script>

<style>
.contract-index .message-container{
	margin-bottom: 0;
	font-size: 12px;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}
.contract-index .message-container p{
	margin-bottom: 0;
	font-size: 12px;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}
.contract-table table tr td{
	font-size: 11px!important;
}
.contract-table.resizable .v-data-table__wrapper th,
.contract-table.resizable .v-data-table__wrapper td {
	border-right: 1px solid #cacaca;
}
.first-column-custom{
	position: relative;
	padding: 0!important;
}
.last-worked-ribbon{
	background-color: #4CAF50;
	width: 20px;
	height: 100%;
  /* border-top: 30px solid #4CAF50;
  border-right: 30px solid transparent; */
}
.last-worked-ribbon .ribbon-icon{
}
.chip-subcontract {
	max-width: 200px;
	height: auto !important;
	padding: 3px 15px !important;
}
.chip-subcontract .v-chip__content {
	white-space: normal;
	line-height: 1.1;
}
.chips-label {
	font-size: 9px !important;
	font-weight: 600;
	color: #959595;
	text-transform: uppercase;
	letter-spacing: 0.5px;
}
.chips-name {
	font-size: 11px !important;
	font-weight: 600;
	color: #333;
}
.chips-subtitle {
	font-size: 9px !important;
	color: #666;
}
.gap-1 {
	gap: 8px;
}
.column-subcontracts-included{
	min-width: 180px;
}
.column-project {
	min-width: 300px;
}
.column-status {
	min-width: 150px;
}
.subcontracts-list {
	display: flex;
	flex-direction: column;
	gap: 4px;
}
.subcontract-item {
	display: flex;
	align-items: center;
	gap: 6px;
	padding: 0;
	transition: all 0.15s ease;
}
.subcontract-item:hover {
	opacity: 0.8;
}
.subcontract-icon {
	flex-shrink: 0;
	color: #959595;
}
.subcontract-item:hover .subcontract-icon {
	color: #524D4D;
}
.subcontract-content {
	display: flex;
	flex-direction: column;
	gap: 1px;
	min-width: 0;
}
.subcontract-name {
	font-size: 11px !important;
	font-weight: 500;
	color: #333;
	line-height: 1.2;
	word-break: break-word;
}
.subcontract-subtitle {
	font-size: 10px !important;
	color: #666;
	font-weight: 400;
	line-height: 1.1;
	word-break: break-word;
}
</style>